var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sales_report",
    "data-name": "sales report",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.288,
    height: 9.905,
    viewBox: "0 0 11.288 9.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M298.02,235.8l1.371-1.459s.177-.258.305,0l.957,1.914,1.045-1.242-.075-.122,1.276-1.683a.341.341,0,0,1,.6,0c.3.421.746,1,.746,1l1.154-1.554.434-.421.835-1.154s.245-.095.238.153c-.177.254-.961,1.333-.961,1.333l-.227.6-1.194,1.7s-.292.376-.638-.08c-.319-.466-.689-.968-.689-.968l-1.245,1.581-.5.332-.655.842s-.217.234-.339-.081c-.142-.305-.93-1.859-.93-1.859l-1.3,1.34S298.02,236.045,298.02,235.8Z",
    transform: "translate(-296.864 -229.946)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M274.518,203.02h4.873c.417,0,.606.185.606.606q0,2.852,0,5.705a.731.731,0,0,1-.006.119.29.29,0,0,1-.56.052.614.614,0,0,1-.022-.236q0-2.723,0-5.447c0-.159-.036-.215-.207-.215q-4.694.008-9.388,0c-.15,0-.206.034-.206.2q.008,3.449,0,6.9c0,.2.092.2.24.2q4.117,0,8.234,0c.06,0,.12,0,.179,0a.291.291,0,0,1,.3.3.279.279,0,0,1-.315.281c-.6,0-1.194.007-1.79,0-.165,0-.226.044-.211.211a2.542,2.542,0,0,1,0,.437c-.013.154.038.209.2.2.4-.01.8,0,1.193,0a.475.475,0,0,1,.214.029.282.282,0,0,1,.175.3.268.268,0,0,1-.247.247,1.332,1.332,0,0,1-.179,0l-6.186,0c-.033,0-.066,0-.1,0a.293.293,0,1,1,0-.585c.344-.008.689,0,1.034,0,.451,0,.451,0,.447-.446,0-.4,0-.4-.4-.4q-1.372,0-2.745,0c-.428,0-.621-.189-.621-.617q0-3.628,0-7.256a.53.53,0,0,1,.6-.6Zm.006,9.314h0c.324,0,.649,0,.974,0,.117,0,.169-.035.163-.158-.008-.179-.008-.358,0-.536,0-.109-.035-.153-.149-.153q-.994.005-1.988,0c-.1,0-.14.04-.138.141,0,.185.005.371,0,.557,0,.112.038.151.149.149C273.861,212.332,274.192,212.335,274.523,212.335Z",
    transform: "translate(-269.027 -203.02)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M372.51,242.383a2.818,2.818,0,0,1,2.408-2.961,2.7,2.7,0,0,1,2.35.8,2.766,2.766,0,0,1,.315,3.511.251.251,0,0,0,.039.394c.615.6,1.22,1.216,1.829,1.825a1.249,1.249,0,0,1,.151.157.276.276,0,0,1-.014.38.265.265,0,0,1-.377,0,3.3,3.3,0,0,1-.271-.262c-.581-.581-1.165-1.159-1.74-1.746a.208.208,0,0,0-.328-.031,2.762,2.762,0,0,1-3.723-.491A2.615,2.615,0,0,1,372.51,242.383Zm5-.2a2.261,2.261,0,0,0-2.2-2.228,2.227,2.227,0,1,0,2.2,2.228Z",
    transform: "translate(-368.384 -237.944)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReport);
export default __webpack_public_path__ + "static/media/sales-report.b250cd0e3fe40b7a0637c85de779290e.svg";
export { ForwardRef as ReactComponent };